"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Max(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M13.354 17.07c.607 0 1.085.147 1.437.443.352.296.531.702.541 1.217v2.106c.004.436.072.77.201 1.002v.074h-1.48a1.654 1.654 0 0 1-.141-.426c-.273.342-.654.514-1.142.514-.45 0-.831-.136-1.143-.407a1.292 1.292 0 0 1-.471-1.02c0-.517.19-.907.573-1.17.378-.265.933-.395 1.66-.395h.457v-.252c0-.439-.19-.659-.567-.659-.351 0-.527.174-.527.522h-1.481c0-.46.196-.833.586-1.119.391-.287.891-.43 1.497-.43zm-4.311 0c.963 0 1.459.582 1.485 1.748v3.094H9.041V18.91c0-.242-.04-.42-.123-.53-.082-.113-.232-.168-.449-.168a.701.701 0 0 0-.654.391l.005.061v3.248H6.335V18.92c0-.249-.038-.43-.119-.54-.078-.113-.23-.168-.453-.168-.282 0-.5.131-.65.391v3.31h-1.48v-4.756H5.02l.05.558c.336-.43.788-.646 1.357-.646.6 0 1.006.24 1.216.716.322-.477.79-.716 1.399-.716zm8.367.087l.668 1.31.69-1.31h1.54l-1.253 2.316 1.312 2.439H18.82l-.746-1.406-.734 1.406h-1.555l1.318-2.44-1.248-2.315h1.555zm-3.564 2.642h-.43c-.518 0-.773.231-.773.693 0 .136.045.244.134.328a.499.499 0 0 0 .348.125.813.813 0 0 0 .459-.119.74.74 0 0 0 .262-.268V19.8zM12 5c.26 0 .51.1.71.29l3 3c.39.39.39 1.03 0 1.42-.39.39-1.03.39-1.42 0L13 8.41V13c0 .55-.45 1-1 1s-1-.45-1-1V8.42L9.71 9.71c-.39.39-1.03.39-1.42 0-.39-.39-.39-1.03 0-1.42l3-3a.55.55 0 0 1 .09-.07c.03-.03.07-.05.1-.07.05-.03.09-.05.14-.07.06-.03.12-.05.19-.061.06-.009.13-.019.19-.019zm9-3c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h18z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Max;
